let handler: (() => void) | null = null;

export const registerFeatureDisabledHandler = (fn: () => void): void => {
  handler = fn;
};

export const getFeatureDisabledHandler = (): (() => void) | null => handler;
